const approvalRoutes = [
  {
    path: "/approvals",
    name: "Approvals",
    component: () => import("./pages/Approvals.vue"),
    // component: () => import("@/_action-plan/pages/ActionPlans.vue"),
    meta: {
      translated: "Aprovações",
      auth: true,
      // permission: { act: "read", on: "Approvals" },
    }
  },
  {
    path: "/approvals/create",
    name: "CreateApproval",
    component: () => import("./pages/OneApproval.vue"),
    meta: {
      translated: "Criar Aprovação",
      auth: true
    }
  },
  {
    path: "/approvals/edit/:id",
    name: "CreateApproval",
    component: () => import("./pages/OneApproval.vue"),
    meta: {
      translated: "Criar Aprovação",
      auth: true
    }
  }
];

export default approvalRoutes;
